import {
  questionCreateSchema,
  questionSchema,
} from "@/schema/console/simple-assessments/Question";
import { z } from "zod";

export const subCategorySchema = z.object({
  id: z.number(),
  content: z.string(),
  questions: z.array(questionSchema),
});

export const subCategoryCreateSchema = subCategorySchema
  .omit({
    id: true,
  })
  .extend({
    questions: z.array(questionCreateSchema),
  });
